module.exports = __webpack_public_path__ + "6eaa9a742d852968c0037cf5c6117759.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/cancel.svg
// module id = ./app/images/cancel.svg
// module chunks = 3